module.exports = __webpack_public_path__ + "static/grilled-cheese-09a16dd42eb554c56bf3663f019d12e4.eot";